<template>
  <app-shell breadcrumbs="Home , Profile">
    <form @submit.prevent="updateProfile">
      <div class="row no-gutters mt-4">
        <div class="align-items-center col-12 d-flex justify-content-between">
          <h5 class="ml-create-service__title">Manage your profile</h5>

          <div class="ml-btn-group">
            <button class="ml-btn ml-btn--md tingg-primary-button" type="submit">Save</button>
          </div>
        </div>
      </div>

      <ml-group class="my-4 mr-2" title="Service information">
        <template slot="content">
          <div class="row my-4 d-flex align-items-end justify-content-between">
            <div class="col-6">
              <div :class="{'form-group': true, 'has-error': errors.has('service_name') }">
                <label class="mula-form-group__label control-label" for="service_name">Service name</label>
                <input v-validate="'required|min:3'"
                       class="mula-form-group__input form-control"
                       id="service_name"
                       name="service_name"
                       type="text"
                       autocomplete="service_name"
                       v-model="service_name"
                >
                <span v-show="errors.has('service_name')" class="help is-danger">
              {{ errors.first('service_name') }}
            </span>
              </div>
            </div>
          </div>
        </template>
      </ml-group>

      <ml-group class="my-4 mr-2" title="Profile information">
        <template slot="content">
          <div class="row my-4">
          <div class="col-6">
            <div :class="{'form-group': true, 'has-error': errors.has('full_name') }">
              <label class="mula-form-group__label control-label" for="user_full_name">Full name</label>
              <span class="help muted subtle-text mt-0 mb-2">Please provide your full name separated by spaces</span>
              <input v-validate="'required|min:5'"
                     class="mula-form-group__input form-control"
                     id="user_full_name"
                     name="user_full_name"
                     type="text"
                     autocomplete="user_full_name"
                     v-model="user_full_name"
              >
              <span v-show="errors.has('user_full_name')" class="help is-danger">
                {{ errors.first('user_full_name') }}
              </span>
            </div>
          </div>
          <div class="col-6">
            <div :class="{'form-group': true, 'has-error': errors.has('phone_number') }">
              <label class="mula-form-group__label control-label" for="user_phone_number">Phone number</label>
              <span class="help muted subtle-text mt-0 mb-2">Please provide a mobile number with the country code</span>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">+</span>
                </div>
                <input v-validate="'required|phone_number'"
                       class="mula-form-group__input form-control"
                       id="user_phone_number"
                       name="user_phone_number"
                       type="text"
                       autocomplete="user_phone_number"
                       v-model="user_phone_number"
                >
              </div>
              <span v-show="errors.has('user_phone_number')" class="help is-danger">
                {{ errors.first('user_phone_number') }}
              </span>
            </div>
          </div>
        </div>
        </template>
      </ml-group>

      <ml-group class="my-4 mr-2" title="Business information">
        <template slot="content">
          <div class="row my-4">
            <div class="col-6">
              <div :class="{'form-group': true, 'has-error': errors.has('full_name') }">
                <label class="mula-form-group__label control-label" for="full_name">Contact name</label>
                <span class="help muted subtle-text mt-0 mb-2">Please provide your full name separated by spaces</span>
                <input v-validate="'required|min:5'"
                       class="mula-form-group__input form-control"
                       id="full_name"
                       name="full_name"
                       type="text"
                       autocomplete="full_name"
                       v-model="full_name"
                >
                <span v-show="errors.has('full_name')" class="help is-danger">
                  {{ errors.first('full_name') }}
                </span>
              </div>
            </div>
            <div class="col-6">
              <div :class="{'form-group': true, 'has-error': errors.has('phone_number') }">
                <label class="mula-form-group__label control-label" for="phone_number">Contact phone number</label>
                <span class="help muted subtle-text mt-0 mb-2">Please provide a mobile number with the country code</span>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">+</span>
                  </div>
                  <input v-validate="'required|phone_number'"
                         class="mula-form-group__input form-control"
                         id="phone_number"
                         name="phone_number"
                         type="text"
                         autocomplete="phone_number"
                         v-model="phone_number"
                  >
                </div>
                <span v-show="errors.has('phone_number')" class="help is-danger">
                  {{ errors.first('phone_number') }}
                </span>
              </div>
            </div>
          </div>

          <div class="row my-4">
            <div class="col-6">
              <div :class="{'form-group': true, 'has-error': errors.has('business_name') }">
                <label class="mula-form-group__label control-label" for="business_name">Business name</label>
                <input v-validate="'required|min:3'"
                       class="mula-form-group__input form-control"
                       id="business_name"
                       name="business_name"
                       type="text"
                       autocomplete="business_name"
                       v-model="business_name"
                >
                <span v-show="errors.has('business_name')" class="help is-danger">
                  {{ errors.first('business_name') }}
                </span>
              </div>
            </div>
            <div class="col-6">
              <div :class="{'form-group': true, 'has-error': errors.has('country_of_operation') }">
                <label class="mula-form-group__label control-label" for="country_of_operation">
                  Country of operation
                </label>
                <select v-validate="'required'"
                        class="mula-form-group__input form-control"
                        name="country_of_operation"
                        id="country_of_operation"
                        v-model="country_of_operation"
                >
                  <option v-for="country in countries" :value="country.code" v-text="country.name"></option>
                </select>
                <span v-show="errors.has('country_of_operation')" class="help is-danger">
                  {{ errors.first('country_of_operation') }}
                </span>
              </div>
            </div>
          </div>
        </template>
      </ml-group>
    </form>
  </app-shell>
</template>


<script>
  import _ from 'lodash'
  import { mapActions, mapGetters } from 'vuex'
  import { Validator } from 'vee-validate'
  import Config from '@/api/config'
  import Group from '@/components/Group'
  import PhoneNumber from 'awesome-phonenumber'
  import Shell from '@/components/Shell'
  import ServicesService from '@/api/services/service'
  import UsersService from '@/api/services/user'

  const logInfo = !!(process.env.NODE_ENV !== 'production')

  export default {
    components: {
      'app-shell': Shell,
      'ml-group': Group
    },

    computed: {
      ...mapGetters('services', ['currentService']),
      ...mapGetters('user', ['clientInfo', 'userInfo']),
      base_currency () {
        return Config.CURRENCIES[this.country_of_operation]
      },
      countries () {
        return Config.COUNTRIES
      }
    },

    data () {
      return {
        business_name: '',
        country_of_operation: '',
        full_name: '',
        user_full_name: '',
        phone_number: '',
        user_phone_number: '',
        service_name: ''
      }
    },

    methods: {
      ...mapActions('user', ['updateUser']),
      ...mapActions('user', ['updateClient']),
      ...mapActions('services', ['updateService']),
      attachCustomValidators () {
        Validator.extend('phone_number', {
          getMessage: field => `The phone number provided is not a valid phone number.`,
          validate: value => new Promise((resolve) => {
            let isPhoneNumberValid = PhoneNumber(`+${value}`).isValid()
            resolve({
              valid: isPhoneNumberValid
            })
          })
        })
      },
      populateProfile () {
        this.business_name = this.clientInfo.client_name
        this.service_name = this.currentService.serviceName
        this.full_name = this.clientInfo.contactPerson
        this.phone_number = this.clientInfo.contactMsisdn
        this.user_full_name = `${this.userInfo.firstName} ${this.userInfo.lastName}`
        this.user_phone_number = this.userInfo.MSISDN
        this.country_of_operation = this.clientInfo.businessCountryCode
      },
      updateProfile () {
        this.$validator.validateAll()
          .then(result => {
            logInfo && console.log('Did the update fields pass validation?', result)

            if (result) {
              // Update service
              ServicesService.updateService({
                service: {
                  clientCode: this.clientInfo.client_code,
                  serviceCode: this.currentService.serviceCode,
                  serviceName: this.service_name
                }
              })
                .then(response => {
                  logInfo && console.log('The service was updated properly', response)
                  this.updateService({
                    ...(_.pick(this.currentService, ['serviceCode', 'serviceID'])),
                    serviceName: this.service_name
                  })
                  UsersService.updateClient({
                    client: {
                      businessCountryCode: this.country_of_operation,
                      clientCode: this.clientInfo.client_code,
                      clientName: this.business_name,
                      defaultCurrencyCode: (this.base_currency !== undefined && this.base_currency !== null) ? this.base_currency.code : undefined,
                      fullName: this.full_name,
                      mobileNumber: this.phone_number
                    }
                  })
                    .then(response => {
                      logInfo && console.log('The client was updated properly', response)
                      this.updateClient({
                        businessCountryCode: this.country_of_operation,
                        clientCode: this.clientInfo.client_code,
                        clientName: this.business_name,
                        defaultCurrencyCode: (this.base_currency !== undefined && this.base_currency !== null) ? this.base_currency.code : undefined,
                        contactPerson: this.full_name,
                        contactMsisdn: this.phone_number
                      })
                      UsersService.updateUserProfile({
                        user: {
                          clientCode: this.clientInfo.client_code,
                          emailAddress: this.userInfo.emailAddress,
                          fullName: this.user_full_name,
                          mobileNumber: this.user_phone_number
                        }
                      })
                        .then(response => {
                          logInfo && console.log('The user was updated properly', response)
                          this.updateUser({
                            firstName: this.user_full_name,
                            lastName: '',
                            MSISDN: this.user_phone_number,
                            emailAddress: this.userInfo.emailAddress
                          })
                          this.$snackbar.open({
                            message: `Updating your profile was successful`,
                            type: 'is-success',
                            position: 'is-bottom',
                            queue: false,
                            actionText: 'OK'
                          })
                        })
                    })
                })
                .catch(reason => {
                  logInfo && console.log('Profile update failed: =>', reason)
                  this.$snackbar.open({
                    message: `Updating your profile failed`,
                    type: 'is-error',
                    position: 'is-bottom',
                    queue: false,
                    actionText: 'RETRY',
                    onAction: () => {
                      this.updateProfile()
                    }
                  })
                })
            }
          })
          .catch(reason => {
            logInfo && console.log('The update fields could not be validated', reason)
          })
      }
    },

    mounted () {
      this.attachCustomValidators()
      this.populateProfile()
    },

    name: 'Profile'
  }
</script>


<style lang="scss">
  @import "../styles/theme";

  .ml-create-service__title {
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/Profile.vue